import React, { useState } from "react";
import "../App.css";
import FiveGridChart from "../component/FiveGridChart/FiveGridChart";
import SecondFiveGridChart from "../component/SecondFIveGridChart/SecondFIveGridChart";
import prevs from "../images/prevs.svg";
import next from "../images/next.svg";
import Header from "../component/Header";

const ChartReportsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
        <Header/>
      {/* Render components based on currentPage */}
      {currentPage === 1 && <FiveGridChart />}
      {currentPage === 2 && <SecondFiveGridChart />}

      {/* Pagination Controls */}
      <div className="btn-container">
        <a
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          style={{
            marginRight: "15px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
          }}
          className="arrow left"
        >
          <img src={prevs} alt="prevs" />
        </a>
        <a
          onClick={() => handlePageChange(2)}
          disabled={currentPage === 2}
          style={{
            cursor: currentPage === 2 ? "not-allowed" : "pointer",
          }}
          className="arrow right"
        >
          <img src={next} alt="next" />
        </a>
      </div>
    </div>
  );
};


export default ChartReportsPage